import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useAdminAuth } from '../../../context/AdminAuthContext';

const AdminLayoutContent = () => {
  const { admin } = useAdminAuth();
  const isSupportRole = admin?.role === 'support';
  const panelTitle = isSupportRole ? 'Support Panel' : 'Admin Panel';
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="admin-layout admin-layout--mobile">
      <header className="admin-mobile-bar">
        <button
          type="button"
          className="admin-mobile-menu-btn"
          aria-label="Open menu"
          aria-expanded={sidebarOpen}
          onClick={() => setSidebarOpen(true)}
        >
          <span className="admin-mobile-menu-bars" aria-hidden="true">
            <span />
            <span />
            <span />
          </span>
        </button>
        <strong className="admin-mobile-bar-title">{panelTitle}</strong>
        <div className="admin-mobile-bar-user">
          {admin?.email ? (
            <span className="admin-mobile-bar-email">{admin.email}</span>
          ) : null}
          <span className="admin-mobile-bar-avatar" aria-hidden="true">
            {admin?.email?.[0]?.toUpperCase() || 'A'}
          </span>
        </div>
      </header>

      {sidebarOpen ? (
        <button
          type="button"
          className="admin-sidebar-backdrop"
          aria-label="Close menu"
          onClick={closeSidebar}
        />
      ) : null}

      <aside className={`admin-sidebar-paper is-drawer${sidebarOpen ? ' is-open' : ''}`}>
        <Sidebar onClose={closeSidebar} />
      </aside>

      <main className="admin-main admin-main--mobile">
        <Outlet />
      </main>
    </div>
  );
};

const AdminLayout = () => <AdminLayoutContent />;

export default AdminLayout;
